export type ResponseOfferImage = {
	id?: number;
	image_kind?: number;
	url: string;
	src?: string;
};

export type OfferImage = {
	id?: number;
	imageKind?: number;
	url?: string;
	src?: string;
};

export function normalizeOfferImage(image: ResponseOfferImage): OfferImage {
	return {
		id: image.id,
		imageKind: image.image_kind,
		url: image.url,
		...(image.src && { src: image.src }),
	};
}
